import React, { Component } from 'react';
import MarketingSection from "../marketingSection";
import { withLocalize } from "react-localize-redux";
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";
import { connect as connectFormik } from "formik";
import { connect } from "react-redux";
import { domainActions } from "../../../store/domainStore";
import { unicornAttributes } from "../../../store/marketingListStore";
import { bindActionCreators } from 'redux';
import BbInput from '../../styling/bbInput';

class LegalForm extends Component {
    render() {
        return (
            <MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false}>
                <BbInput type='custom' label={this.props.translate('Report.CompanyIdentification.LegalForm')} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        data='legal-form-types'
                        name='legalForm'
                        popupSize='large'
                        title={this.props.translate("Report.CompanyIdentification.LegalForm")}
                        onClick={() => this.props.ensureDomainData('legal-form-types', { addNaturalPerson: false, marketAttributes: unicornAttributes() })}
                        selection={this.props.formik.values.legalForm}
                        handleChange={(all, parent) => this.props.formik.setFieldValue('legalForm', { all: all, parent: parent, checked: true })} />
                } />
            </MarketingSection>
        )
    }
}
export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(LegalForm)));
